import { FormattedMessage } from "react-intl";
import { formatDateLabel } from "../../../helpers/date-time-helper";
import { IAppointmentAccToDate } from "../../../models/response/IDashboardResponse";
import { formatMessage } from "../../../translations/format-message";
import { useHistory } from "react-router-dom";
import RoutesConstants from "../../../constants/routes.constant";
import { getLanguageFromLocalStorage } from "../../../helpers/localstorage-helper";

const WeeklyReservationStatusTable: React.FC<{
  dailyAppointmentDataList: IAppointmentAccToDate[];
  storeId:number;
}> = ({ dailyAppointmentDataList, storeId }) => {
  const history = useHistory();
  if (!dailyAppointmentDataList || dailyAppointmentDataList.length < 14)
    return null;
  const language = getLanguageFromLocalStorage();
  const week1 = dailyAppointmentDataList.slice(0, 7);
  const week2 = dailyAppointmentDataList.slice(7, 14);
  const redirectToReservation = (date: string) => {
    history.push({
      pathname: RoutesConstants.ReservationManagement,
      state: { selectedDate: date, selectedStoreId: storeId },
    });
  };

  return (
    <table className="table table-bordered text-center align-middle">
      <thead>
        <tr>
          <th colSpan={7} className="bg-secondary text-start">
            <h3 className="m-0">
              <FormattedMessage id="weekly_reservation_status" />
            </h3>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          {week1.map((item, idx) => {
            const label = formatDateLabel(item.AppointmentDate);
            return (
              <td
                className={`py-2 text-white fw-bold text-center 
              ${
                label.day == "Sun"
                  ? "bg-danger"
                  : label.day == "Sat"
                  ? "bg-info"
                  : "bg-primary"
              }`}
                key={idx}
              >
                {label.date}
                <small className="fw-normal ms-xl-1 d-block d-xl-inline">
                  (<FormattedMessage id={label.day} />)
                </small>
              </td>
            );
          })}
        </tr>
        <tr>
          {week1.map((item, idx) => (
            <td className="text-center bg-white py-3" key={idx}>
              {
                storeId > 0 ? 
                <button
                  type="button"
                  onClick={() => {redirectToReservation(item.AppointmentDate)}}
                  >
                  {item.Count} <FormattedMessage id="booking_count"/>
                </button> :
                <>
                  {item.Count} <FormattedMessage id="booking_count"/>
                </>
              }
            </td>
          ))}
        </tr>
        <tr>
          {week2.map((item, idx) => {
            const label = formatDateLabel(item.AppointmentDate);
            return (
              <td
                className={`py-2 text-white fw-bold text-center 
              ${
                label.day == "Sun"
                  ? "bg-danger"
                  : label.day == "Sat"
                  ? "bg-info"
                  : "bg-primary"
              }`}
                key={idx}
              >
                {label.date}
                <small className="fw-normal ms-xl-1 d-block d-xl-inline">
                  (<FormattedMessage id={label.day} />)
                </small>
              </td>
            );
          })}
        </tr>
        <tr>
          {week2.map((item, idx) => (
            <td className="text-center bg-white py-3" key={idx}>
              {
                storeId > 0 ? 
                <button
                  type="button"
                  onClick={() => {redirectToReservation(item.AppointmentDate)}}
                  >
                  {item.Count} <FormattedMessage id="booking_count"/>
                </button> :
                <>
                  {item.Count} <FormattedMessage id="booking_count"/>
                </>
              }
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
};

export default WeeklyReservationStatusTable;
